import { render, staticRenderFns } from "./Menubar.vue?vue&type=template&id=231467d3&scoped=true&"
import script from "./Menubar.vue?vue&type=script&lang=ts&"
export * from "./Menubar.vue?vue&type=script&lang=ts&"
import style0 from "./Menubar.vue?vue&type=style&index=0&id=231467d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231467d3",
  null
  
)

export default component.exports